import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AccountProductType } from '@models/account.model'
import { AccountService } from '@services/account.service'
import { resolveHomeUrl } from '@utils/role-home.util'

/** Área do visitante (spec 048, RF 18): só com o papel; sem ele, a área de origem. Com ele, o produto VIS. */
export const visitorProductGuard: CanActivateFn = () => {
	const accountService = inject(AccountService)
	const router = inject(Router)

	if (!accountService.isVisitor) {
		return router.createUrlTree([resolveHomeUrl(accountService)])
	}

	if (accountService.currentProduct?.type !== AccountProductType.VIS) {
		accountService.syncRoleProducts()
		accountService.changeProduct(AccountProductType.VIS)
	}

	return true
}
